import Card from './Card.vue';
export default Card;


// WEBPACK FOOTER //
// ./src/components/parts/catalog/card/index.ts